///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/filters/slug.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/i18n.ts" />
namespace TotalContest {
    import IAngularEvent = angular.IAngularEvent;
    import Controller = TotalCore.Common.Controller;
    import Slug = TotalCore.Common.Filters.Slug;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import I18nService = TotalCore.Common.Providers.I18nService;
    import UniqueIdService = TotalCore.Common.Providers.UniqueIdService;

    @Controller('controllers.totalcontest')
    export class ContestPagesCtrl {
        constructor(private $scope, private SettingsService: SettingsService, private UniqueIdService: UniqueIdService, private I18nService: I18nService) {
            $scope.pages = this.SettingsService.settings['pages'].other;
            $scope.collapsed = {};
            $scope.$watch('pages', (pages, oldPages) => {
                angular.forEach(pages, (page, pageIndex) => {
                    page.id = Slug.filter(page.title, '-');
                });
            }, true);
        }

        collapsePages() {
            this.setCollapsedForAll(true);
        }

        deleteFields() {
            if (confirm(this.I18nService.__(['Are you sure?']))) {
                this.SettingsService.settings['pages'].other = [];
            }
        }

        deletePage(index: number, ask: boolean = false, $event: IAngularEvent) {
            if (ask && !confirm(this.I18nService.__('Are you sure?'))) {
                $event.stopPropagation();
                return false;
            }

            this.SettingsService.settings['pages'].other.splice(index, 1);
            return false;
        }

        expandPages() {
            this.setCollapsedForAll(false);
        }

        insertPage(args) {
            this.collapsePages();

            args = angular.extend({}, {
                id: 'untitled',
                title: 'Untitled',
                content: '',
                collapsed: false,
            }, args);

            this.SettingsService.settings['pages'].other.push(args);
        }

        isCollapsed(index) {
            return this.$scope.collapsed.hasOwnProperty(index) ? this.$scope.collapsed[index] : true;
        }

        setCollapsedForAll(collapsed) {
            this.SettingsService.settings['pages'].other.forEach(function (item) {
                item.collapsed = collapsed;
            });
        }

        toggle(index, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            this.$scope.collapsed[index] = this.$scope.collapsed.hasOwnProperty(index) ? !this.$scope.collapsed[index] : false;

            // this.SettingsService.settings['pages'].other[index].collapsed = !this.SettingsService.settings['pages'].other[index].collapsed;
            return false;
        }
    }
}
